module.exports = __webpack_public_path__ + "img/Grey-Granite-Marble-PBR-texture-3D-free-download-High-resolution-Unity-Unreal-Vray-render-full.1fb9195d.jpg";